import React from "react";

const EyeOpenIcon = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			{...props}>
			<path
				d="M1.00123 9.94204C0.666259 9.35862 0.666257 8.64148 1.00122 8.05805C2.76372 4.98823 5.58284 3 8.75985 3C11.9368 3 14.7559 4.9882 16.5184 8.05799C16.8534 8.64142 16.8534 9.35855 16.5184 9.94198C14.7559 13.0118 11.9368 15 8.75981 15C5.58283 15 2.76373 13.0118 1.00123 9.94204Z"
				stroke="#F7F7FC"
				stroke-width="0.75"
			/>
			<path
				d="M11.0098 9C11.0098 10.2426 10.0024 11.25 8.75977 11.25C7.51713 11.25 6.50977 10.2426 6.50977 9C6.50977 7.75736 7.51713 6.75 8.75977 6.75C10.0024 6.75 11.0098 7.75736 11.0098 9Z"
				stroke="#F7F7FC"
				stroke-width="0.75"
			/>
		</svg>
	);
};

export default EyeOpenIcon;
